import { ObjectCache } from 'Src/ng2/shared/services/object-cache/object-cache.service';
import { IStateService } from 'angular-ui-router';
import { Toggles } from 'Src/ng2/shared/constants/toggles.constant';
import { USER_ROLE_PERMISSIONS_FOR_STATES } from 'Src/ng2/shared/constants/user-role-permissions-for-states.constant';
import { ImUser } from 'Src/ng2/shared/services/im-models/im-user';
import { IWindowService } from 'angular';

angular.module('nv.routes.main').config(function($stateProvider) {
  /* istanbul ignore next */
  $stateProvider
    .state(`main.network`, {
      abstract: false,
      url: '/network',
      data: {
        roles: USER_ROLE_PERMISSIONS_FOR_STATES['main.network'],
      },
      views: {
        '': {
          template: require('../../../ng2/network/network-container.html'),
          controller: [
            '$state',
            ($state: IStateService) => {
              if ($state.current.url === '/network') $state.go('main.network.dashboard');
            },
          ],
        },
        'leftSideNav@main.network.container': {
          template: `
          <network-left-side-nav
            [current-user]=$resolve.currentUser
          ></network-left-side-nav>
          `,
        },
        'content@main.network.container': {
          template: `<div ui-view class="content"></div>`,
        },
      },
      // Can we remove toggle?
      onEnter: (ImUser: ImUser, $state) => {
        const accessNetworkView = ImUser.isToggleOn(Toggles.TOGGLE_NETWORK_DASHBOARD);
        if (!accessNetworkView) $state.go('main.home');
      },
      onExit: ($window: IWindowService) => {
        $window.document.title = 'Data Portal';
      },
    })

    // dashboard
    .state('main.network.dashboard', {
      url: '/dashboard/:filters',
      template: `<network-top-level [filters]="$resolve.filters"></network-top-level>`,
      resolve: {
        filters: [
          '$stateParams',
          'ObjectCache',
          function($stateParams, ObjectCache) {
            const { filters } = $stateParams;

            if (!filters) return null;

            return new Promise(resolve => {
              return ObjectCache.getObject(filters).then(filters => {
                resolve(filters);
              });
            });
          },
        ],
      },
    })

    .state('main.network.midlevel', {
      url: '/midlevel/:madlibModel',
      params: { tileData: null, filters: null },
      resolve: {
        initialState: [
          '$stateParams',
          'ObjectCache',
          function($stateParams, ObjectCache) {
            const { madlibModel, tileData } = $stateParams;
            return new Promise(resolve => {
              return ObjectCache.getObject(madlibModel || tileData).then(defaults => {
                resolve({ origin: madlibModel ? 'madlibModel' : 'tileData', defaults });
              });
            });
          },
        ],
        topLevelFilters: [
          '$stateParams',
          function($stateParams) {
            const { filters } = $stateParams;
            return filters;
          },
        ],
      },
      template: `<network-mid-level [initial-state]="$resolve.initialState" [top-level-filters]="$resolve.topLevelFilters"  [current-user]="$resolve.currentUser"></network-mid-level>`,
    })

    .state('main.network.studentLevel', {
      url: '/studentLevel/:midlevelData',
      template: `<network-student-level [midlevel-data]="$resolve.midlevelData"></network-student-level>`,
      resolve: {
        midlevelData: [
          '$stateParams',
          'ObjectCache',
          function($stateParams, ObjectCache) {
            const { midlevelData } = $stateParams;
            return new Promise(resolve => {
              return ObjectCache.getObject(midlevelData).then(midlevelData => resolve(midlevelData));
            });
          },
        ],
      },
      onEnter: (currentUser, ImUser: ImUser, $state) => {
        const accessNetworkStudentLevel = ImUser.canSeeNetworkStuLvl(currentUser);
        if (!accessNetworkStudentLevel) $state.go('main.network.dashboard');
      },
    });
});
